import React from "react";
import { Moon, Sun } from "@/lib/icons";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle({ showLabel = false, className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const light = theme === "light";
  const label = light ? "Use dark mode" : "Use light mode";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={`theme-toggle inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 p-1 text-white/70 transition hover:border-fuchsia-400/40 hover:text-fuchsia-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-fuchsia-500/50 ${showLabel ? "pr-3" : ""} ${className}`}
    >
      <span className={`inline-flex h-7 w-7 items-center justify-center rounded-full transition ${light ? "bg-[#7F00FF] text-white" : "bg-white/10 text-fuchsia-200"}`}>
        {light ? <Sun size={14} /> : <Moon size={14} />}
      </span>
      {showLabel && <span className="text-xs font-semibold">{light ? "Light" : "Dark"}</span>}
    </button>
  );
}
